<template>
	<button
		ref="trigger"
		type="button"
		class="comments-bubble"
		:class="bubbleClass"
		@click="open"
	>
		<svg
			class="bubble-icon"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<!-- Внутренность облачка — видна только когда есть комменты (.read/.unread) -->
			<path class="bubble-fill" d="M9 3L5 4L3 6L2 9L3 12L4 14.5L6.5 17L7.5 20C8 19.6667 9.1 19 9.5 19C9.9 19 10.6667 18 11 17.5C11.8333 17.3333 13.6 17 14 17C14.4 17 16.5 16.3333 17.5 16C18.1667 15.6667 19.6 14.9 20 14.5C20.5 14 20.5 12 21 11.5C21.5 11 21.5 9.5 21.5 9C21.5 8.5 20.5 6 20 6C19.5 6 18.5 5 18 4.5C17.5 4 17 4 16.5 3.5C16 3 14 3 13.5 3H9Z"/>
			<!-- Контур-полоса — рисуется поверх заливки, виден всегда -->
			<path class="bubble-outline" d="M8.68944 1.85271C8.2883 1.95529 7.60865 2.18161 7.24086 2.33517C6.69041 2.565 6.63303 2.59254 6.05784 2.90283C3.96617 4.03123 2.37642 5.8504 1.75478 7.83621C1.51266 8.60958 1.42553 9.17904 1.42505 9.99075C1.42413 11.5726 1.90113 12.9656 2.90949 14.3331C3.58074 15.2434 4.66386 16.2088 5.67186 16.7956L5.92542 16.9431L5.93396 19.7002L5.94261 22.5003L5.94311 22.6567L6.0648 22.5583L8.58599 20.5182L11.0833 18.4974L11.2789 18.5164C11.634 18.5514 12.6143 18.5413 13.1364 18.4981C17.0712 18.1731 20.4566 16.0729 21.8855 13.0531C22.1929 12.4037 22.3654 11.8515 22.5093 11.0598C22.5566 10.7997 22.5776 10.3809 22.5748 9.96307C22.5721 9.54505 22.5454 9.11989 22.4946 8.8468C22.27 7.63476 21.902 6.75579 21.194 5.73916C19.8341 3.78624 17.4422 2.29041 14.7813 1.72204C14.3011 1.61943 13.6418 1.52034 13.1981 1.48416C12.6634 1.44058 11.8056 1.41238 11.5454 1.43069C10.1444 1.52938 9.69573 1.59546 8.68944 1.85271ZM7.59545 19.1047C7.58939 19.1094 7.58352 19.114 7.57787 19.1184C7.57538 19.0353 7.57311 18.9178 7.57119 18.7737C7.5672 18.4738 7.56473 18.0598 7.56473 17.6041V15.9468V15.9009L7.52388 15.88L7.10933 15.6679C4.91982 14.548 3.54038 12.8965 3.14244 10.9393C3.09614 10.7116 3.07436 10.3352 3.07757 9.95377C3.08079 9.5724 3.10892 9.19573 3.15908 8.9677C3.29708 8.34028 3.45915 7.90413 3.74696 7.38417C4.89825 5.30434 7.28216 3.80379 10.2261 3.32239C10.8506 3.22029 11.1611 3.20281 12.1759 3.21466C12.9511 3.22369 13.2583 3.24226 13.6545 3.30285C14.9818 3.50577 16.1013 3.87402 17.1836 4.46283C18.9728 5.43624 20.2234 6.85687 20.7141 8.46048C20.8785 8.99757 20.9318 9.37608 20.9308 10.0079C20.9294 10.8249 20.7875 11.4734 20.451 12.2025C19.5449 14.1655 17.4741 15.7471 14.9159 16.4157C13.8783 16.6867 13.2851 16.7592 12.0751 16.7617C11.5146 16.7629 10.9615 16.7511 10.8426 16.7364C10.8426 16.7364 10.8426 16.7364 10.8426 16.7364L10.616 16.7082L10.5844 16.7043L10.5597 16.7242L9.02321 17.9638C8.60076 18.3045 8.21432 18.6142 7.932 18.8388C7.79082 18.9511 7.67583 19.0419 7.59545 19.1047Z"/>
		</svg>
		<span class="counter">{{ commentCount }}</span>
	</button>

	<CommentsPopup
		v-if="opened"
		:entity-type-name="entityTypeName"
		:entity="entity"
		:target="$refs.trigger"
		:visible="opened"
		@update:visible="onVisibleChange"
	/>
</template>

<style lang="scss" src="./CommentsButton.scss"/>

<script lang="ts">
import BaseEntity from '@/core/misc/BaseEntity';

export default defineComponent({
	name: 'CommentsButton',

	props: {
		/** Тип сущности на бэке (например 'assembly', 'order', 'paymentRequest') */
		entityTypeName: {
			type:     String,
			required: true,
		},
		entity: {
			type:     Object as PropType<BaseEntity>,
			required: true,
		},
	},

	data() {
		return {
			opened: false,
		};
	},

	computed: {
		/**
		 * Количество комментов:
		 *   - сохранённая сущность → берём из commentsStatus с бэка
		 *   - новая (несохранённая) → считаем локальный буфер commentaries
		 */
		commentCount(): number {
			if (this.entity.isExisting) {
				return this.entity.commentsStatus?.qty ?? 0;
			} else {
				return this.entity.commentaries.length;
			}
		},

		/**
		 * Состояние кнопки:
		 *   - .read   — есть комментарии, все прочитаны (серая заливка)
		 *   - .unread — есть непрочитанные (синяя заливка)
		 *   - без класса — нет комментариев (только серый контур)
		 */
		bubbleClass(): Record<string, boolean> {
			if (this.commentCount === 0) {
				return {};
			}
			return {
				unread: Boolean(this.entity.commentsStatus?.isUnread),
				read:   !this.entity.commentsStatus?.isUnread,
			};
		},
	},

	methods: {
		open(): void {
			this.opened = true;
		},

		onVisibleChange(value: boolean): void {
			this.opened = value;
		},
	},
});
</script>